export default "__VITE_ASSET__C7iHFI6n__"